/**
 * THE CATEGORY WORKSPACE TAB — «Огляд», «Жеребкування», «Поєдинки»,
 * «Фінальний результат» … — remembered across page loads (14 Oct 2026:
 * «вкладку теж зберігай»), with the competition and category it belongs to
 * (selectedCompetition.js). A tab the category cannot open yet falls back to
 * «Огляд» on screen, exactly as a click would; the choice itself is kept, so
 * the tab opens once the category's facts arrive. Logging out forgets it.
 */
const STORAGE_KEY = 'categoryWorkspaceTab';

export const getWorkspaceTab = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || 'overview';
    } catch (e) {
        return 'overview';
    }
};

export const storeWorkspaceTab = tab => {
    try {
        if (tab && 'overview' !== tab) {
            window.localStorage.setItem(STORAGE_KEY, tab);
        } else {
            window.localStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        /* private browsing: the tab still switches, it just forgets */
    }
};
